<template>
  <div class="form_field flex_field_column border-bottom">
    <div class="label_container">
      <div class="add-info">
        <label for="">Informazioni aggiuntive:</label>
      </div>
      <div class="text_container">
        <p class="add-equipments">
          In questo campo si deve inserire il chilometraggio e gli equipaggiamenti opzionali
          dell’auto per farli rientrare nella quotazione (attenzione non tutti gli equipaggiamenti
          opzionali sono considerati dal mercato). Altre indicazioni e note saranno vagliate dal
          Team di Quotauto, ma considerazioni che esulano da quanto considerato nelle nostre stime,
          come lo stato d’uso del veicolo, saranno ignorate
        </p>
      </div>
    </div>
    <div class="container_textarea">
      <textarea
        name="add_description"
        id="add-desc"
        cols="10"
        rows="5"
        placeholder="Descrivi la tua auto e la relativa offerta"
        required="true"
      ></textarea>
    </div>
  </div>
</template>

<script>
export default {
    name: 'FormFieldAddInfo',
}
</script>



// WEBPACK FOOTER //
// resources/js/app/components/FormFieldAddInfo.vue